import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";
import "./Style.css";
import Logo from "./logo-nkp.jpg"
class Menu extends Component {
  constructor() {
    super();
    this.state = {
      Allergens: [],
      base_url: global.BaseUrl,
    }
  }

  componentDidMount() {
    $(".open-offcanvas").click(function () {
      $("body").addClass("offcanvas-on");
    });

    $(".close-offcanvas").click(function () {
      $("body").removeClass("offcanvas-on");
    });

    $(document).on('click', 'a[href^="#/"]', function(e) {
      e.stopImmediatePropagation();
    });

    fetch(`${this.state.base_url}/allergens`).then((resp) => {
      resp.json().then((result) => {
        this.setState({ Allergens: result });
      })
    });
  }
  render() {
    const { Allergens } = this.state;
    const { tab2 = [], tab3 = [], tab4 = [], tab5 = [] } = this.props;
    return (
      <>
        <header >

          <div className="header-main">
            <div className="container-fluid">
              <div className="open-offcanvas">☰</div>

              <div className="header-logo">
                <Link to="/" className="logo logo-static"><img src={Logo} alt="NKP" className="logo-img " /></Link>
              </div>
              <nav id="main-nav-offcanvas" className="main-nav-wrapper">
                <div className="close-offcanvas-wrapper"><span className="close-offcanvas">x</span></div>
                <div className="main-nav">
                  <ul id="main-nav" className="nav nav-pills">
                    {/* <li><Link className="close-offcanvas" to="/">Overview</Link></li> */}
                    {/* <li><Link className="close-offcanvas" to="/Lobby_Reception">Lobby Reception</Link></li> */}
                    <li><Link className="close-offcanvas" to="/">Employee Dining</Link></li>
                    <li><Link className="close-offcanvas" to="/catering-menu">Catering Menu</Link></li>
                    <li><Link className="close-offcanvas" to="/Work_Cafes">Work Cafes</Link></li>
                    <li><Link className="close-offcanvas" to="/Sustainability">Sustainability</Link></li>
                    {/* <li><Link className="close-offcanvas" to="/Healthy_Recipes">Healthy Recipes</Link></li>             */}


                    <li className="dropdown current-menu-item showhim"><Link className="dropdown-toggle">
                      Wellness</Link><i className="fa fa-angle-down btn-open-dropdown"></i>
                      <ul className="showme dropdown-content" role="menu">
                        <li className="current-menu-item drop-menu"><Link className="drop-list" to="/Healthy_Recipes">Healthy Recipes</Link></li>
                        <li className="current-menu-item drop-menu"><Link className="drop-list" to="/Seasonal_Recipes">Seasonal Recipes</Link></li>
                      </ul>
                    </li>

                    <li className="dropdown current-menu-item showhim-update"><Link className="dropdown-toggle">
                      Updates</Link><i className="fa fa-angle-down btn-open-dropdown"></i>
                      <ul className="showme-update dropdown-content" role="menu">
                        {Allergens.map(Allergens_page =>
                          <li key={Allergens_page.sub_page} className="current-menu-item drop-menu"><Link className="drop-list" to={`${Allergens_page.sub_page}`}>{Allergens_page.sub_page}</Link></li>
                        )}
                        {tab2.map(page =>
                          <li key={page.sub_page} className="current-menu-item drop-menu"><Link className="drop-list" to={`${page.sub_page}`}>{page.sub_page}</Link></li>
                        )}
                        {tab3.map(new_page =>
                          <li key={new_page.sub_page} className="current-menu-item drop-menu"><Link className="drop-list" to={`${new_page.sub_page}`}>{new_page.sub_page}</Link></li>
                        )}
                        {tab4.map(new_page_new =>
                          <li key={new_page_new.sub_page} className="current-menu-item drop-menu"><Link className="drop-list" to={`${new_page_new.sub_page}`}>{new_page_new.sub_page}</Link></li>
                        )}
                        {tab5.map(new_page_new =>
                          <li key={new_page_new.sub_page} className="current-menu-item drop-menu"><Link className="drop-list" to={`${new_page_new.sub_page}`}>{new_page_new.sub_page}</Link></li>
                        )}
                      </ul>
                    </li>
                    {/* <li><Link className="close-offcanvas" to="/Updates">Updates</Link></li> */}
                    {/* <li><Link className="close-offcanvas"></Link></li> */}


                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </header>

      </>
    );
  }
}

export default Menu;